<template>
    <div class="flex flex-center-sp">
        <div class="about-body flex flex-col scroll">
            <div class="margin-top-xxl margin-bottom-xl  flex flex-center-sp font-xxl font-bold">更新日志</div>
            <time-axis :timeData="timeData"></time-axis>
        </div>
    </div>

</template>

<script>

import TimeAxis from '@/components/timeAxis/TimeAxis' 

 export default {
    name:'UpdateLog',
    components: {
        TimeAxis
    },
    data() {
      return {
        timeData:[
           {"date":"2026-06-28", "list":['增加日历功能']},           
           {"date":"2026-04-25", "list":['个人空间查询条件增加记忆功能']},          
           {"date":"2025-03-05", "list":['测试类项目过滤后再添加导致数据丢失问题']},
           {"date":"2025-02-28", "list":['试卷提交时提示输入姓名','试卷提交后显示考试成绩']},
           {"date":"2025-02-27", "list":['试题类文档增加对填空题的处理']},
           {"date":"2025-02-24", "list":['试题编辑增加从题库导入功能，可以从本人的文档或收藏的文档中的题库提取']},
           {"date":"2025-02-22", "list":['测试类问题添加后最新的排在最前面',"存在敏感词无法保存改为可保存，并将敏感词替换为*"]},
           {"date":"2025-01-30", "list":['pc端增加回收站批量删除功能',"pc端测试问题类文档增加下载导入模板及文件导入", "pc端试卷类文档增加下载导入模板及文件导入","pc端试卷类文档增加克隆功能"]},
           {"date":"2025-01-20", "list":['pc端增加试卷功能',"小程序端增加试卷功能"]},
           {"date":"2025-01-09", "list":['pc端增加测试文档功能',"小程序端增加测试文档功能"]},
           {"date":"2024-12-29", "list":['增加待办功能',"修改查看返回不能显示之前状态问题"]},
           {"date":"2024-04-14", "list":['文档显示增加关键字统计']},
           {"date":"2024-04-11", "list":['增加回复及回复查看功能']},
           {"date":"2024-04-09", "list":['修复编辑本人文档不添加更新内容问题','增加切换版本时如果是本人版本直接添加更新内容','评论内容实现自动换行']},
           {"date":"2024-04-08", "list":['个人空间页增加搜索功能','修复文件移动不成功问题']},
           {"date":"2024-04-02", "list":['增加打印功能，可另存PDF','下发更新增加指定人员发送，可对指定人员当前文档添加富文本信息']},
           {"date":"2024-02-20", "list":['文档增加查看功能，可查看富文本内容']},
           {"date":"2024-02-07", "list":['增加便签功能']},
           {"date":"2024-01-16", "list":['富文本，增加倒序功能','收到更新文本时文本排前面']},
           {"date":"2023-12-30", "list":['富文本，字体选择框增加对楷体支持']},
           {"date":"2023-12-29", "list":['富文本增加插入日期时间功能，格式为：月-日 周几 方便写日记/日志',"增加下载pdf文件"]},
           {"date":"2023-12-28", "list":['增加下发历史显示']},
           {"date":"2023-12-27", "list":['修复分享空白页问题','修复移动端查看图片超出问题']},
           {"date":"2023-12-26", "list":['增加每次编辑生成历史版本','增加历史版本查看功能']},
           {"date":"2023-12-22", "list":['修复分享显示问题','修复版本栏滚动显示问题']},
           {"date":"2023-12-21", "list":['编辑他人文档时，增加全部照搬和只要关于我的选项处理','增加移动端分享显示']},
           {"date":"2023-12-20", "list":['文本编辑增加内容处理：保留关键字所在行，可以应用于只看自己的任务','增加下发更新功能，将最新内容下发至其他版本人']},
           {"date":"2023-12-18", "list":['增加文件对比功能','修复部分样式问题']},
           {"date":"2023-12-17", "list":['最近浏览、我的收藏增加搜索功能','修复编辑日志重复问题','修复用户登录缓存问题','修复重复分享问题']},
           {"date":"2023-12-16", "list":['文档编辑增加自动保存功能','修复消息显示问题','修复了其他已知问题']},
           {"date":"2023-12-15", "list":["上线发布"]},
        ] 
      }
    },

 }
    

</script>

<style scoped>
  .about-body {
    margin-top: 60px;
    width: 1000px;
    min-height: 500px;
    max-height: 1000px;

  }
  .about-word {
    line-height: 30px;

  }
  





</style>


// WEBPACK FOOTER //
// src/views/UpdateLog.vue